var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sign-in-pages"},[(_vm.onStageRoute)?_c('AuthStage',{ref:"stage",attrs:{"busy":_vm.busy,"intro":_vm.introAllowed}},[_c('transition',{attrs:{"name":"auth-card","mode":"out-in"}},[_c('router-view')],1)],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }